export const REF_BLOODPOOL_LOCATION = 'REF-BLOODPOOL';

/**
 * RECIP 1.0 new-lesion reference condition: uptake above blood pool
 * (lesion SUVmax > REF-BLOODPOOL SUVmax). A reminder for the reader only.
 */
export const NEW_UPTAKE_RESULT = {
  ABOVE: 'above',
  NOT_ABOVE: 'not-above',
  PENDING: 'pending', // a value is not computed yet
  NE: 'ne',
};

export function findRefBloodPoolROI(rois = [], links = []) {
  const matched = rois.filter((roi) => {
    const link = links.find((l) => l.link_id === roi.link_id);
    return link?.location === REF_BLOODPOOL_LOCATION;
  });
  if (matched.length === 0) return { roi: null, reason: 'no-ref-bloodpool' };
  if (matched.length > 1) return { roi: null, reason: 'multiple-ref-bloodpool' };
  return { roi: matched[0], reason: null };
}

export function computeBloodPoolRef(bpStats, refReason = null) {
  if (refReason) return { suvMax: null, reason: refReason, source: null };
  if (!bpStats) return { suvMax: null, reason: 'ref-bloodpool-pending', source: null };
  if (bpStats.ne || !Number.isFinite(bpStats.suvMax)) {
    return { suvMax: null, reason: 'ref-bloodpool-ne', source: null };
  }
  return { suvMax: bpStats.suvMax, reason: null, source: bpStats.source ?? null };
}

const round2 = (v) => Math.round(v * 100) / 100;

export function compareNewLesionUptake(lesionStats, bpRef) {
  if (!bpRef || bpRef.reason === 'ref-bloodpool-pending' || !lesionStats) {
    return { result: NEW_UPTAKE_RESULT.PENDING, reason: null };
  }
  if (bpRef.suvMax == null) return { result: NEW_UPTAKE_RESULT.NE, reason: bpRef.reason };
  if (lesionStats.ne || !Number.isFinite(lesionStats.suvMax)) {
    return { result: NEW_UPTAKE_RESULT.NE, reason: lesionStats.reason || 'lesion-suv-ne' };
  }
  const above = round2(lesionStats.suvMax) > round2(bpRef.suvMax);
  return {
    result: above ? NEW_UPTAKE_RESULT.ABOVE : NEW_UPTAKE_RESULT.NOT_ABOVE,
    reason: null,
  };
}